import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';


function Footer() {



    return (
        <div className="footer">
            
            
            <div class="footer-links">
                <a href="https://www.facebook.com/archer.nicholson.5/" class="fa fa-facebook" target="_blank">Facebook</a>
                <a href="https://www.instagram.com/mr_archer_/" class="fa fa-instagram" target="_blank">Instagram</a>
                <a href="https://www.linkedin.com/in/archer-nicholson-554829204/" class="fa fa-linkedin" target="_blank">Linkedin</a>
                <a href="https://github.com/mrarcher2000" class="fa fa-github" target="_blank">GitHub</a>
            </div>
        </div>
    )

}


export default Footer;